import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { Subject, Observable } from 'rxjs';
import * as XLSX from 'xlsx';
import { GatewayService } from 'src/app/gateway.service';
import { takeUntil, switchMap, debounceTime, tap, finalize } from 'rxjs/operators';
import { MatPaginator, MatTableDataSource, MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, PageEvent } from '@angular/material';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { ComponentTabController } from 'src/app/tab-controller';
import { saveAs } from 'file-saver';
import { NgxSpinnerService } from 'ngx-spinner';
import { UploadServiceService } from 'src/app/services/upload-service.service';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { TipoServicioService } from '../tipo-servicio.service';

@Component({
  selector: 'app-mapa-tecnico',
  templateUrl: './mapa-tecnico.component.html',
  styleUrls: ['./mapa-tecnico.component.scss']
})
export class MapaTecnicoComponent implements OnInit {
  private destroy$ = new Subject<void>();
  sanitizeurl: any = null;
  clienteactivo: any = {};

  constructor(
    public _sanitizer: DomSanitizer,
    public gateway: GatewayService,
    private snackbar: MatSnackBar,
    private dialog: MatDialog,
    public localSave: LocalSaveService,
    public tabController: ComponentTabController,
    private spinner: NgxSpinnerService,
    private uploadService: UploadServiceService,
    private _tipoServicio: TipoServicioService
  ) { }

  ngOnInit() {
    this._tipoServicio.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.loadIframe();
    });
  }

  loadIframe() {

    // const payload = {
    //   id_contrata: 1, // idcontrata
    //   id_cliente: 1,
    //   id_usuario: 1, // idagente
    //   id_caso: '',
    //   direccion: 'Calle 123',
    //   cod_cuenta: '123456',
    // };

    this.clienteactivo = this.localSave.get('inittab');

    // console.log('-------usupgv ------------')
    // console.log(this.localSave.get('usuarioPGV'))

    let payload = {};
    const tipoActual = this._tipoServicio.getValorActual();
    if (this.localSave.get('usuarioPGV').idrol == 16) {
      payload = {
        id_admin: tipoActual.IDU,
        id_contrata: null,
        id_area: tipoActual.IDAREA,
        supcontrata_id: null
      };
    }
    else if (this.localSave.get('usuarioPGV').idrol == 23 || this.localSave.get('usuarioPGV').idrol == 24 || this.localSave.get('usuarioPGV').idrol == 27) {
      payload = {
        id_admin: null,
        id_contrata: null,
        id_area: tipoActual.IDAREA,
        supcontrata_id: this.localSave.get('usuarioPGV').IDCONTRATA2
      };
    }
    else {
      payload = {
        id_admin: tipoActual.IDPADRE,
        id_contrata: tipoActual.IDU,
        id_area: tipoActual.IDAREA,
        supcontrata_id: null
      };
    }

    this.gateway.get('gettoken', { payload })
      .then((result: any) => {
        // Generar el token
        // const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZF9hZG1pbiI6MSwiaWRfY29udHJhdGEiOjF9.iQP-V2oGFQp3V72y3paZjRTzPGW7bvixm3x8hbC4mmQ'

        const token = result.token;
        if (this.localSave.get('usuarioPGV').idrol == 16) {
          this.sanitizeurl = this._sanitizer.bypassSecurityTrustResourceUrl(`${environment.baseUrlPGViFrame}/list?token=${token}`);
        }else{
          this.sanitizeurl = this._sanitizer.bypassSecurityTrustResourceUrl(`${environment.baseUrlPGViFrame}/agent-map?token=${token}`);
        }
        this.spinner.hide();
      }).catch((error: any) => {
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

